import { useContext } from "react";
import { ChartsContext } from "../components/ChartsContext";
import { Question } from "../models/Question";
import { ReturnBar } from "../components/ui";
import { ChartsBlock } from "../components/charts/ChartsBlock";
import { Typography, CircularProgress } from "@mui/material";

export default function QuestionsData(): JSX.Element {
  const chartsContext = useContext(ChartsContext);
  const { survey, questions, isLoading } = chartsContext;

  let questionBlock = { questions: [] as Question[] } as {
    questions: Question[];
    type: "type1" | "type2";
  };
  const questionBlocks = [] as (typeof questionBlock)[];

  // Función auxiliar para determinar el tipo de bloque
  const getBlockType = (questionType: string): "type1" | "type2" | null => {
    switch (questionType) {
      case "checkbox":
      case "dropdown":
      case "emotionsratings":
      case "imagepicker":
      case "matrix":
      case "radiogroup":
      case "rating":
        return "type1";
      case "comment":
      case "text":
        return "type2";
      default:
        return null;
    }
  };

  let lastBlockType: "type1" | "type2" | null = null;
  
  for (const question of questions) {
    const currentBlockType = getBlockType(question.type);
    
    if (
      currentBlockType !== lastBlockType &&
      questionBlock.questions.length > 0
    ) {
      if (lastBlockType) {
        questionBlock.type = lastBlockType;
        questionBlocks.push(questionBlock);
        questionBlock = {
          questions: [] as Question[],
        } as {
          questions: Question[];
          type: "type1" | "type2";
        };
      }
    }
    
    if (currentBlockType) {
      questionBlock.questions.push(question);
      lastBlockType = currentBlockType;
    }
  }
  
  if (questionBlock.questions.length > 0 && lastBlockType) {
    questionBlock.type = lastBlockType;
    questionBlocks.push(questionBlock);
  }
  console.log("questionBlocks:", questionBlocks);

  /*
  const questionBlocksQuestionsLength = questionBlocks.map(
    (value) => value.questions.length
  );
  */

  let questionBlocksStartIndexes = [1];
  let sumOfQuestionsLength = 1;
  for (const questionBlock of questionBlocks) {
    questionBlocksStartIndexes.push(
      questionBlock.questions.length + sumOfQuestionsLength
    );
    sumOfQuestionsLength += questionBlock.questions.length;
  }
  console.log("questionBlocksStartIndexes:", questionBlocksStartIndexes);

  return (
    <>
      <div style={{ backgroundColor: '#F9F9F9', minHeight: '100vh', paddingBottom: '20px' }}>
        <ReturnBar title={survey.title} />
        <Typography
          fontSize={"20px"}
          fontFamily={"IBM Plex Sans"}
          fontWeight={"600"}
          color={"#1A237E"}
          paddingLeft={"30px"}
          paddingBottom={"16px"}
        >
          Questions data
        </Typography>
        {isLoading && (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', paddingTop: '80px', gap: '16px' }}>
            <CircularProgress size={40} thickness={4} />
            <Typography variant="h6" color="primary" style={{ fontFamily: 'IBM Plex Sans' }}>
              Loading questions...
            </Typography>
          </div>
        )}
        {!isLoading && questionBlocks.map((questionBlock, index) => (
          <div
            key={index}
            style={{ marginBottom: '16px' }}
          >
            <ChartsBlock
              questions={questionBlock.questions}
              type={questionBlock.type}
              startIndex={questionBlocksStartIndexes[index]}
            />
          </div>
        ))}
      </div>
    </>
  );
}
